/**
 * 规则验证器
 * @param {Object[]} validations 验证配置数组
 * @returns {Promise<boolean>} 所有字段验证通过时返回解决状态为true的Promise，否则返回带有失败消息的reject状态Promise
 */
export async function rulesValidator(validations) {
  for (const { filed, value, rules = [] } of validations) {
    for (const { message, validator } of rules) {
      const result = await validator(value);
      if (!result) {
        return Promise.reject({
          filed,
          message,
        });
      }
    }
  }
  return Promise.resolve(true);
}
